import React, { Component } from 'react'
import RichTextEditor, { createEmptyValue } from 'react-rte'
import ColorButton from '../Controls/ColorButton'
import { newMaxLengthValidator } from '../../helpers'
import Condition from '../Condition'
import { ImageAsBlob } from '../ImageAsBlob'

/**
 * check for links in our html editor
 * and adds targett and rel attrs
 * to prevent the links to open in the same page
 */
const editorOptions = {
  entityStyleFn: entity => {
    const entityType = entity.get('type').toLowerCase()
    if (entityType === 'link') {
      const data = entity.getData()
      return {
        element: 'a',
        attributes: {
          href: data.url,
          target: '_blank',
          rel: 'noopener',
        },
      }
    }
    return undefined
  },
}

export class EditSnippetInfo extends Component {
  state = {
    value: createEmptyValue(),
    name: '',
    error: undefined,
    sanitizedValue: '',
  }

  componentDidMount() {
    const { text = '', name } = this.props
    this.setState({
      value: createEmptyValue().setContentFromString(text, 'html'),
      name,
      sanitizedValue: text.toString('html', editorOptions),
    })
  }

  componentWillReceiveProps(newProps) {
    if (this.props.name !== newProps.name) {
      this.setState({ name: newProps.name })
    }
  }

  checkTextLength = description => {
    let div = document.createElement('div')
    div.innerHTML = description.toString('html')
    let text = div.textContent || div.innerText || ''
    const labelError = newMaxLengthValidator(350)(text)
    if (labelError) {
      this.setState({ error: labelError })
    } else {
      this.setState({ error: undefined })
    }
  }

  onChange = value => {
    const sanitizedValue = value.toString('html', editorOptions)
    this.setState({ value, sanitizedValue })
    this.checkTextLength(value)
  }

  renderBlobOrSelecteIcon() {
    const { file, crop, width, height, selectedIcon } = this.props
    if (selectedIcon && selectedIcon.icon && selectedIcon.icon.url) {
      return (
        <div>
          <img className="br-100" src={selectedIcon.icon.url} alt="icon" />
        </div>
      )
    } else if (file && crop) {
      return (
        <ImageAsBlob
          display
          src={file.preview}
          crop={crop}
          width={width}
          height={height}
          radius={`${width}px`}
        />
      )
    } else {
      return null
    }
  }

  render() {
    const { onSave, onDelete, cancel, selectedIcon } = this.props
    const { value, name, error, sanitizedValue } = this.state

    return (
      <div>
        <div className="ph4 pv2">
          <form className="mb2">
            <div className="dib v-mid w3 mr2 h3 ba br-100">
              {this.renderBlobOrSelecteIcon()}
            </div>
            <div className="dib v-mid w-80">
              <input
                className="h2 bg-transparent bb dark-gray tl w-100 mb2 b--moon-gray"
                placeholder="Influencer name"
                value={name}
                onChange={event => this.setState({ name: event.target.value })}
              />
            </div>
          </form>
          <RichTextEditor
            className="min-vh-30 mb2"
            value={value}
            onChange={this.onChange}
          />
          <Condition shouldRender={error}>
            <div className="tl dark-red">{error}</div>
          </Condition>
        </div>

        <div className="bg-light-gray f7 ph4 pv3 w-100 flex items-center justify-center">
          <div className="w-90 tr">
            {onDelete && (
              <ColorButton
                colorClass="red"
                borderClass="b--red"
                className="mr2"
                onClick={onDelete}
              >
                Delete
              </ColorButton>
            )}

            <ColorButton
              colorClass="gray"
              borderClass="b--gray"
              className="mr2"
              onClick={cancel}
            >
              Cancel
            </ColorButton>

            <ColorButton
              colorClass={`${
                !selectedIcon.icon || error ? 'gray' : 'op-brand'
              }`}
              borderClass={`${
                !selectedIcon.icon || error ? 'b--gray' : 'b--op-brand'
              }`}
              disabled={!selectedIcon.icon || error}
              onClick={e => {
                e.preventDefault()
                onSave({
                  text: sanitizedValue,
                  name,
                })
              }}
            >
              Save
            </ColorButton>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Snippets/EditSnippetInfo.js